<template>
    <transition name="slide-fade" mode="out-in">
        <div class="container" :key="selected">
            <div class="row-wrap" id="default-banner" v-if="selected == null">
                <h4>How useful do you think this course page is?</h4>
                <div id="icon-content" class="row">
                    <span class="minor-text" @click="clickIcon(0)">
                        <LikeIcon :style="iconStyles(0)" />
                        Useful
                    </span>
                    <span class="minor-text" @click="clickIcon(1)">
                        <DislikeIcon :style="iconStyles(1)" />
                        Not useful
                    </span>
                </div>
            </div>
            <div class="row-wrap" id="dislike-banner" v-if="selected == 1">
                <h4>What can we do better?</h4>
                <div class="row-wrap" id="dislike-content">
                    <div id="fb-container">
                        <span
                            class="fb-field"
                            ref="feedback"
                            contenteditable="true"
                            placeholder="Tell us what we could change"
                        ></span>
                    </div>
                    <span class="submit-btn" @click="submitFeedback">
                        Submit
                    </span>
                </div>
            </div>
            <div id="like-banner" v-if="selected == 0">
                <h4 class="primary-text"><strong>Thank you for your review</strong></h4>
            </div>
        </div>
    </transition>
</template>

<script>
import LikeIcon from "@/assets/icons/actions/inline.like-icon.svg";
import DislikeIcon from "@/assets/icons/actions/inline.dislike-icon.svg";
import { firestore } from "@/firebase.js";

export default {
    name: "FeedbackBanner",
    components: {
        LikeIcon,
        DislikeIcon,
    },
    methods: {
        iconStyles(idx) {
            return {
                fill: "#F4E5DE",
                opacity: this.selected !== null && idx == this.selected ? 1 : 0.5685,
            };
        },
        clickIcon(idx) {
            if (this.selected !== null) {
                return;
            }
            if (idx == 0) {
                this.submit({
                    createdAt: new Date(),
                    liked: true,
                });
            } else {
                this.selected = idx;
            }
        },
        submitFeedback() {
            let feedback = this.$refs.feedback.innerHTML;
            if (feedback.length == 0) {
                return;
            } else {
                let obj = {
                    createdAt: new Date(),
                    liked: false,
                    feedback: feedback,
                };
                this.submit(obj);
            }
        },
        submit(obj) {
            firestore
                .collection("university")
                .doc("uw")
                .collection("feedback")
                .add(obj)
                .then(() => {
                    this.selected = 0;
                });
        },
    },
    data() {
        return {
            selected: null,
        };
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_main.scss";

h4 {
    line-height: 28px;
}

.container {
    padding: 48px;
    width: inherit;

    background: #fafafa;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
}

#dislike-content {
    flex: 1;
    justify-content: flex-end;
}

#default-banner,
#dislike-banner {
    width: inherit;
    justify-content: space-between;
    align-items: center;
}

#like-banner {
    text-align: center;
}

#icon-content {
    margin-left: -48px;
    width: auto;
    justify-content: center;

    span {
        margin-left: 48px;
    }

    > * {
        cursor: pointer;
    }
}

#fb-container {
    display: flex;
    align-items: center;

    flex: 1;
    min-width: 200px;
    width: 100%;
    max-width: 30vw;

    border-bottom: 1px solid #999999;

    span {
        min-width: 100%;
        max-width: 100%;

        font-size: 16px;
        line-height: 24px;
    }

    span:active,
    span:focus {
        outline: 0;
        border: 0;
        --moz-outline-style: none;
    }

    span[contenteditable]:empty::before,
    span[contenteditable]:empty:focus::before {
        content: attr(placeholder);
        color: #999999;
    }
}

#dislike-banner {
    h4 {
        width: fit-content;
        margin-right: 18px;
    }
}

.submit-btn {
    margin-left: 18px;
    padding: 12px 24px;

    height: fit-content;

    background: $primary;
    border-radius: 12px;

    color: white;
    text-align: center;

    cursor: pointer;
}

@media only screen and (max-width: 860px) {
    #dislike-content {
        flex-wrap: wrap;
        min-width: -webkit-fill-available;
        justify-content: inherit;
        margin-top: 24px;
    }

    #fb-container {
        max-width: 100%;
    }

    #icon-content {
        margin-left: 0;
        margin-top: 24px;
        justify-content: space-between;
        width: 100%;

        .minor-text {
            margin-left: 0;
        }
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    #dislike-content {
        justify-content: center;
    }

    #fb-container {
        min-width: 100%;
    }

    .submit-btn {
        margin-left: 0;
        margin-top: 16px;
        width: 100%;
    }
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(100%);
    opacity: 0;
}
</style>
